import Model from '@/models/Model'

export default class WhSubfamily extends Model {
    resource() {
        return 'wh_subfamily'
    }
}